import { GameFacade } from "../facade-scene/facade-scene";
import { SceneDataInterface } from "../../interfaces/scene-data-interface";
import { StartSceneElementsSpecifications } from "./start-specifications";
import { GameSceneIdsStrings } from "../../settings/game-constants-strings/game-scene-ids-string";
import { ButtonComponent } from "../../components/button-component/button-component";
import { EventsTouchedGameObjectsStrings } from "../../settings/game-constants-strings/game-events-strings";
import { GameSceneElementsString } from "../../settings/game-constants-strings/game-elements-strings";
import { ColorsValue } from "../../settings/game-constants-strings/text-styles-string";
import { loadAssetsArrayGame } from "../../functions/load-assets-functions/load-assets-functions";
import { gameAssets } from "../../settings/game-assets";
import { loadFonts } from "../../functions/font-styles/font-styles-functions";

export class StartScene extends Phaser.Scene {

    private gameFacade: GameFacade;
    private sceneGameObjects;
    // private sceneData: SceneDataInterface;
    
    private sceneBackground: Phaser.GameObjects.Image;
    private playButton: ButtonComponent;
    private helpButton: ButtonComponent;
    private infoButton: ButtonComponent;
    private webpageButton: ButtonComponent;
    

    // init(_sceneData: SceneDataInterface) {
    //     this.sceneData = _sceneData;
    // }

    
    preload() {
        loadFonts();
        loadAssetsArrayGame(this, gameAssets);
    }

    constructor() {
        super({
            key: GameSceneIdsStrings.START_SCENE_ID
        });
        this.sceneGameObjects = new Map();
    }

    create() {  
        this.generateScene();
        this.getElements();
        this.addFunctionality();
    }

    private generateScene() {
        this.gameFacade = new GameFacade(this, StartSceneElementsSpecifications);
        this.sceneGameObjects = this.gameFacade.getGameObjects;
    }

    private getElements() {
        this.sceneBackground = this.sceneGameObjects.get(
            GameSceneElementsString.SCENE_BACKGROUND
        ).gameObject;
        this.sceneBackground.setTint(ColorsValue.BLACK_HEXADECIMAL_VALUE);
        this.sceneBackground.setAlpha(0.5);

        this.playButton = this.sceneGameObjects.get(
            GameSceneElementsString.SCENE_PLAY_BUTTON
        ).gameObject;
        
        this.helpButton= this.sceneGameObjects.get(
            GameSceneElementsString.SCENE_HELP_BUTTON
        ).gameObject;
        
        this.infoButton = this.sceneGameObjects.get(
            GameSceneElementsString.SCENE_INFO_BUTTON
        ).gameObject;
        
        this.webpageButton = this.sceneGameObjects.get(
            GameSceneElementsString.SCENE_WEB_PAGE_BUTTON
        ).gameObject;
    }

    private addFunctionality() {
        // addTintOnGameButton(this.closeButton);
        this.playButton.setInteractive().on(
            EventsTouchedGameObjectsStrings.POINTERDOWN, () => {
                // this.scene.stop(this.scene.key);
                // const gameData: SceneDataInterface = {
                //     returnSceneName: this.scene.key,
                //     isfirstPlay: true
                // }
                this.scene.start(GameSceneIdsStrings.HELPER_SCENE_ID);
            }
        );

        this.helpButton.setInteractive().on(
            EventsTouchedGameObjectsStrings.POINTERDOWN, () => {
                this.scene.pause();
                const gameData: SceneDataInterface = {
                    returnSceneName: this.scene.key
                }
                this.scene.launch(GameSceneIdsStrings.HELP_SCENE_ID, gameData);
            }
        );
        
        this.infoButton.setInteractive().on(
            EventsTouchedGameObjectsStrings.POINTERDOWN, () => {
                this.scene.pause();
                const gameData: SceneDataInterface = {
                    returnSceneName: this.scene.key
                }
                this.scene.launch(GameSceneIdsStrings.INFO_SCENE_ID, gameData);
            }
        );
        
        this.webpageButton.setInteractive().on(
            EventsTouchedGameObjectsStrings.POINTERDOWN, () => {
                this.openExternalLink();
            }
        );
    }
    
    private openExternalLink () {
        const url = 'https://www.crisweb.me/';
        const s = window.open(url, '_blank');

        if (s && s.focus) {
            s.focus();
        } else if (!s) {
            window.location.href = url;
        }
    }
}